import { FEATURE_FLAGS } from '../../../../featureFlags';
import Bot from './Index.vue';
import BotShow from './Show.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/agent-bots'),
      meta: {
        permissions: ['administrator', 'agent_bot_manage'],
      },
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'agent_bots',
          component: Bot,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator', 'agent_bot_manage'],
          },
        },
        {
          path: ':botId',
          name: 'agent_bot_show',
          component: BotShow,
          meta: {
            featureFlag: FEATURE_FLAGS.AGENT_BOTS,
            permissions: ['administrator', 'agent_bot_manage'],
          },
        },
      ],
    },
  ],
};
